
import { useState } from "react";
import { Grid, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import showToast from "../../../components/Hot-Toast/showToast";
import { customStep, nextStep, update } from "../../../slice/jobSlice";
import { useTMutation } from "../../../utils/useTMutation";
import CheckIcon from '@mui/icons-material/Check'; // Importing the checkmark icon from MUI



const StaffingSolution = () => {
    const { mutateAsync } = useTMutation("/job/addUpdateJob", "post", (data => { return data }));
    const { jobData, step } = useSelector(state => state?.job);
    console.log("jobData", jobData)
    const { userDetails } = useSelector(state => state?.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm({
        resolver: zodResolver(z.object({
            STAFFING_SOLUTION: z.string().min(1, { message: "Staffing Solutions is Required" }),
        })),
        defaultValues: {
            STAFFING_SOLUTION: jobData?.STAFFING_SOLUTION,
        },
    });

    // Define state to keep track of the selected item
    const [selectedSolution, setSelectedSolution] = useState(jobData?.STAFFING_SOLUTION || "");
    // const staffingArray = ["DirectHire", "Nursing", "Allied", "Non Clinical", "Mental Health"];
    const contractTypeArray = [
        { heading: "DirectHire" },
        { heading: "Nursing" },
        { heading: "Allied" },
        { heading: "Non Clinical" },
        { heading: "Mental Health" }
    ];

    const colorArray = ['#4CAF50', '#3BB9E3', '#F6B613', '#073463', '#7E57E2'];
    const onSubmitNext = async (data) => {
        if (jobData?.ID) data.ID = jobData?.ID;
        else data.USER_ID = userDetails.ID;
        try {
            const response = await mutateAsync({ ...data, STEP: jobData.REDIRECT ? 8 : step + 1, HIRING_TYPE: jobData?.HIRING_TYPE });
            if (response.STATUS) {
                dispatch(update(jobData?.ID ? data : response.OUTPUT));
                if (jobData?.REDIRECT) {
                    dispatch(customStep(8));
                    dispatch(update({ "REDIRECT": false }));
                } else {
                    if (data.STAFFING_SOLUTION !== "DirectHire") {
                        dispatch(customStep(2))
                    } else {
                        dispatch(nextStep())
                    }

                }
            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Validation Request failed:", error.message);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleClick = (solution) => {
        if (solution) {
            setSelectedSolution(solution); // Update selected solution
            onSubmitNext({ STAFFING_SOLUTION: solution }); // Submit the selected solution
        } else {
            showToast("error", "Please select at least one Staff");
        }
    };

    return (
        <>
            <Grid container alignItems="center" px={3} pb={3} spacing={2}>
                <Grid item xs={12} sm={12} mt={2}>
                    <Typography variant="h3" className="about-texts">
                        What kind of staffing solution do you need?
                    </Typography>
                </Grid>

                {contractTypeArray.map((val, index) => {
                    const color = colorArray[Math.floor(Math.random() * colorArray.length)];
                    const isSelected = selectedSolution === val.heading; // Check if the current solution is selected
                    return (
                        <Grid
                            item
                            lg={index === 0 || index === 1 || index === 2 || index === 3 || index === 4 ? 6 : 4}
                            // lg={4} 
                            // md={4} 
                            // sm={6} 
                            // xs={12} 
                            p={1}
                            key={index}
                            onClick={() => handleClick(val.heading)}
                            style={{
                                position: 'relative',
                                cursor: "pointer",
                                transition: "transform 0.3s ease",
                                transform: isSelected ? "scale(1.05)" : "scale(1)",
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.05)"; }} // Hover scale
                            onMouseLeave={(e) => { e.currentTarget.style.transform = isSelected ? "scale(1.05)" : "scale(1)"; }} // Revert on hover out
                        >
                            <Grid
                                // p={2}
                                style={{
                                    borderRadius: "3px",
                                    border: `2px solid ${color}`,
                                    backgroundColor: isSelected ? color : "transparent",
                                    position: 'relative',
                                    padding: "25px 10px",
                                    textAlign: "center"
                                }}
                            >
                                {isSelected && (
                                    <CheckIcon
                                        style={{
                                            position: 'absolute',
                                            top: '8px',
                                            right: '8px',
                                            color: '#fff',
                                            fontSize: '24px',
                                        }}
                                    />
                                )}
                                <Grid container>
                                    <Grid item lg={10} pl={2}>
                                        <Typography style={{ color: isSelected ? "#fff" : color }}>
                                            {val?.heading}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </>
    );
};

export default StaffingSolution;
